import React from "react";
import { useAuth } from "../../hooks/useAuth";
import AdminPlacesView from "./home/AdminPlacesView";
import PlaceAdminHomeView from "./home/PlaceAdminHomeView";
import MultiPlaceAdminHomeView from "./MultiPlaceAdminHomeView";

export default function Places() {
  const { isAdmin, isMultiPlaceAdmin } = useAuth();
  return (
    <>
      {isAdmin ? (
        <AdminPlacesView />
      ) : isMultiPlaceAdmin ? (
        <MultiPlaceAdminHomeView />
      ) : (
        <PlaceAdminHomeView />
      )}
    </>
  );
}
